import {
  BROADBAND_OPTIONS,
  EPC_OPTIONS,
  FLOOR_SIZE_OPTIONS,
  HEATING_OPTIONS,
  YEAR_BUILT_OPTIONS,
} from '@propertypal/shared/src/constants/filterOptions';
import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import { SearchParams } from '@propertypal/shared/src/types/search';
import { formatInternalArea, formatYearBuilt } from '@propertypal/shared/src/utils/search/inputFormating';
import Checkbox from '@propertypal/web-ui/src/inputs/Checkbox';
import SelectInput from '@propertypal/web-ui/src/inputs/SelectInput';
import React, { FunctionComponent } from 'react';
import { EPCWrapper, SmartMultiSelect } from './SearchBar.style';
import { Container } from './SmartInputs.style';

interface Props {
  filters: SearchState['filters'];
  handleFilterChange: UseSearchState['handleFilterChange'];
  isNewHomes: boolean;
  searchParams?: SearchParams;
  isIE?: boolean;
}

const SmartInputs: FunctionComponent<Props> = ({ filters, handleFilterChange, isNewHomes, searchParams, isIE }) => {
  return (
    <Container>
      <SmartMultiSelect
        label="Heating Type"
        id="heatingType"
        placeholder=" Heating Type"
        options={HEATING_OPTIONS}
        values={filters.heatingType || []}
        onChange={handleFilterChange('heatingType')}
        testID="heatingType"
      />

      {!isNewHomes && (
        <SelectInput
          ariaLabel="Select Year Built"
          label="Year Built"
          id="yearBuilt"
          options={YEAR_BUILT_OPTIONS}
          value={filters.yearBuilt}
          placeholder="Year Built"
          onChange={handleFilterChange('yearBuilt')}
          testID="yearBuilt"
          wildcard={formatYearBuilt(searchParams?.minYearBuilt, searchParams?.maxYearBuilt)}
        />
      )}

      <SelectInput
        ariaLabel="Select Floor Size"
        label="Floor Size"
        id="floorSize"
        options={FLOOR_SIZE_OPTIONS}
        value={filters.minInternalArea}
        placeholder="Floor Size"
        onChange={handleFilterChange('minInternalArea')}
        testID="floorSize"
        wildcard={formatInternalArea}
      />

      {!isIE && (
        <SelectInput
          ariaLabel="Select Broadband Speed"
          label="Broadband Speed"
          id="broadband"
          options={BROADBAND_OPTIONS}
          value={filters.broadband}
          placeholder="Broadband Speed"
          onChange={handleFilterChange('broadband')}
          testID="broadband"
        />
      )}

      {!isIE && (
        <EPCWrapper>
          <SelectInput
            ariaLabel="Select EPC Rating"
            label="EPC Rating"
            id="epcRating"
            options={EPC_OPTIONS}
            value={filters.epc}
            placeholder="EPC Rating"
            onChange={handleFilterChange('epc')}
            testID="epcRating"
          />

          <Checkbox
            containerStyle={{ marginTop: 10 }}
            label="Include Potential EPC Ratings"
            name="epcRatingType"
            value={filters.includePotentialEpc}
            onValueChange={handleFilterChange('includePotentialEpc')}
            disabled={!filters.epc}
          />
        </EPCWrapper>
      )}
    </Container>
  );
};

export default SmartInputs;
